// Modal.js
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { primaryButtonStyles, secondaryButtonStyles } from "../../Styles/Styles";

const Modal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/get-started");
    onClose(); // Close the modal after navigating
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="login-required-dialog"
      maxWidth="xs" // Adjust modal width as needed
      fullWidth
    >
      <DialogTitle
        id="login-required-dialog"
        sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}
      >
        Login Required
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          variant="body1"
          sx={{ fontFamily: "ClashGrotesk-Regular", letterSpacing: 1 }}
        >
          If you want to see the contact information, please log in.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 1, mb: 1 }}>
        <Button
          size="small"
          variant="contained"
          sx={{
            ...secondaryButtonStyles,
          }}
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          size="small"
          variant="contained"
          sx={{
            ...primaryButtonStyles,
          }}
          onClick={handleLoginClick}
        >
          Login/Register
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
